<template>
    <section class="internal-page faq-page">
        <internal-page-header
            eyebrow="Orientação ao credor"
            title="Dúvidas frequentes"
            description="Encontre respostas para as principais dúvidas sobre processos e atendimento."
        />
        <div class="internal-content">
            <div v-if="description" class="internal-rich-text mb-8" v-html="description"></div>
            <div class="internal-toolbar internal-toolbar--search">
                <div class="internal-toolbar__summary">
                    <h2>Encontre sua resposta</h2>
                    <p>
                        <strong>{{ filteredQuestions.length }}</strong>
                        {{
                            filteredQuestions.length === 1
                                ? 'resposta disponível'
                                : 'respostas disponíveis'
                        }}
                    </p>
                </div>
                <v-text-field
                    v-model="search"
                    label="Buscar uma dúvida"
                    placeholder="Digite o assunto ou a pergunta"
                    outlined
                    dense
                    clearable
                    hide-details
                    prepend-inner-icon="mdi-magnify"
                />
            </div>
            <page-state
                v-if="loading || error || !filteredQuestions.length"
                :loading="loading"
                :error="error"
                inline
                title="Nenhuma pergunta encontrada"
                description="Tente outro assunto ou entre em contato com nossa equipe."
                @retry="load"
            />
            <v-expansion-panels v-else flat class="faq-panels">
                <v-expansion-panel
                    v-for="(question, index) in filteredQuestions"
                    :key="question.id || question.title"
                >
                    <v-expansion-panel-header
                        ><span class="faq-number">{{ String(index + 1).padStart(2, '0') }}</span
                        ><span>{{ question.title }}</span></v-expansion-panel-header
                    >
                    <v-expansion-panel-content
                        ><div class="internal-rich-text" v-html="question.description"></div
                    ></v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
            <div class="faq-contact">
                <span>Não encontrou o que precisava?</span
                ><router-link to="/contato"
                    >Fale com nossa equipe
                    <v-icon size="18" color="secondary">mdi-arrow-right</v-icon></router-link
                >
            </div>
        </div>
    </section>
</template>
<script>
import axios from 'axios';
export default {
    name: 'FaqPage',
    data: () => ({ questions: [], description: '', search: '', loading: true, error: false }),
    computed: {
        filteredQuestions() {
            const term = (this.search || '').toLocaleLowerCase('pt-BR');
            return this.questions.filter((item) =>
                (item.title || '').toLocaleLowerCase('pt-BR').includes(term)
            );
        }
    },
    created() {
        this.load();
        this.loadText();
    },
    methods: {
        async load() {
            this.loading = true;
            this.error = false;
            try {
                const response = await axios.get('/api/faqs', {
                    params: { start: 1, limit: 100000, search: {} }
                });
                this.questions = response.data.content.data;
            } catch (error) {
                this.error = true;
            } finally {
                this.loading = false;
            }
        },
        async loadText() {
            try {
                const response = await axios.get('/api/dynamic-infos/keys', {
                    params: { keys: 'faq-description' }
                });
                this.description = response.data.content.length
                    ? response.data.content[0].value
                    : '';
            } catch (error) {
                this.description = '';
            }
        }
    }
};
</script>
<style scoped>
.faq-panels .v-expansion-panel {
    margin-bottom: 12px;
    border: 1px solid #dedbd4;
}
.faq-panels .v-expansion-panel-header {
    min-height: 80px;
    color: var(--pbb-navy);
    font: 500 17px/1.5 'Plus Jakarta Sans', sans-serif;
}
.faq-number {
    flex: 0 0 46px;
    color: var(--pbb-copper);
    font: 500 12px 'Manrope', sans-serif;
}
.faq-contact {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 18px;
    margin-top: 40px;
    padding-top: 28px;
    border-top: 1px solid #dedbd4;
    font-size: 14px;
    color: var(--pbb-muted);
}
.faq-contact a {
    display: inline-flex;
    align-items: center;
    gap: 12px;
    text-decoration: none;
}
@media (max-width: 600px) {
    .faq-panels .v-expansion-panel-header {
        padding: 20px 16px;
        font-size: 15px;
    }
    .faq-number {
        flex-basis: 32px;
    }
}
</style>
